module.exports = __webpack_public_path__ + "img/rona_3kl.88d06f49.jpg";